import { storage } from '@web/extension-services/background/webapi/storage'

import type { RailgunGasSpeedName } from '@web/utils/railgunShared'

export const RAILGUN_SHIELD_TX_LOG_KEY = 'railgunShieldTxLog'

const MAX_RECORDS = 100

export type RailgunShieldTxRecord = {
  txHash: string
  chainId: number
  amount: string
  recipientAddress: string
  accountAddr: string
  tokenAddress?: string
  feeSpeed?: RailgunGasSpeedName
  timestamp: number
}

function isShieldTxRecord(value: unknown): value is RailgunShieldTxRecord {
  if (!value || typeof value !== 'object') return false
  const v = value as Record<string, unknown>
  return (
    typeof v.txHash === 'string' &&
    typeof v.chainId === 'number' &&
    typeof v.amount === 'string' &&
    typeof v.recipientAddress === 'string' &&
    typeof v.accountAddr === 'string' &&
    typeof v.timestamp === 'number'
  )
}

export function parseRailgunShieldTxLog(raw: unknown): RailgunShieldTxRecord[] {
  if (!Array.isArray(raw)) return []
  return raw.filter(isShieldTxRecord)
}

export async function getRailgunShieldTxLog(): Promise<RailgunShieldTxRecord[]> {
  const raw = await storage.get(RAILGUN_SHIELD_TX_LOG_KEY, [])
  return parseRailgunShieldTxLog(raw)
}

/**
 * Appends a shield tx record (newest first). Trims to MAX_RECORDS. Errors are swallowed.
 */
export async function appendRailgunShieldTxRecord(record: RailgunShieldTxRecord): Promise<void> {
  try {
    const current = await getRailgunShieldTxLog()
    const next = [record, ...current].slice(0, MAX_RECORDS)
    await storage.set(RAILGUN_SHIELD_TX_LOG_KEY, next)
  } catch (err) {
    console.error('appendRailgunShieldTxRecord failed:', err)
  }
}
